/**
 * RegistrationStorageUtil
 * incharge of clientside persistence api for registration objects
 * Author: Oded Sagir
 * @param  Object require -for adding dependencies
 * @return Object         -Class Object
 */
define(function(require) {
    'use strict';

    var LE = require('app');
    var Logger = require("logger");
    var Loader = require("ui/loader/Loader");

    // UTILS
    var Storage =                       require("assets/js/storage");


    var RegistrationStorageUtil = {};
    LE.module("LERegistration", function (LERegistration, LE, Backbone, Marionette, $, _) {
        RegistrationStorageUtil = {
            CONSTANT: {
                DEFAULT_PRODUCT_NAME: "LiveEngage",
                BUY_FLOW: "Buy",
                TRIAL_FLOW: "Trial",
                RETURN_PAGE_BUYNOW: "buyNow",
                AFFILIATE_TIME_TILL_EXPIRATION: 1209600000, //Two weeks: 14*24*60*60*1000
                IMPACT_RADIUS_DATA: "impactRadiusData",
                AFFILIATE_ID: "affiliateId",
                CLICK_ID: "clickId"
            },
            
            saveAffiliateQueryParams: function (args) {
                var clickId = args.clickId;
                var affiliateId = args.affiliateId;
                var options;
                if (clickId !== "") {
                    options = {
                        affiliateId: affiliateId,
                        clickId: clickId
                    };
                    Storage.set(this.CONSTANT.IMPACT_RADIUS_DATA, 
                                JSON.stringify(options), 
                                Storage.TYPE.TTL, 
                                this.CONSTANT.AFFILIATE_TIME_TILL_EXPIRATION);
                }
            },

            getDataFromStorage: function (key) {
                var data = Storage.get(key);
                if (data){
                    var result;
                    try {
                        result = JSON.parse(data);
                    }
                    catch(ex) {
                        LERegistration.logger.error("error while parsing JSON", "RegistrationStorageUtil:getDataFromStorage", ex);
                    }
                    return result;
                } else {
                    return null;
                }
            }

        };


        /**
         * PRIVATE FUNCTIONS 
         * only available inside the closure 
         */

       

    });
    return RegistrationStorageUtil;
});